if (!window.customElements.get("featured-collection-v2-tab")) {
  window.customElements.define(
    "featured-collection-v2-tab",
    class extends HTMLElement {
      constructor() {
        super();
        this.fallbackCarouselButtonOffset = 5;
        this.slider = this.closest(".featured-collection-v2").querySelector(".featured-collection-v2__slider");
        this.radio = this.querySelector("input[type='radio']");
      }

      connectedCallback() {
        const tabTarget = this.radio.dataset.tabTarget;
        this.targetSliderItems = this.radio.closest(".featured-collection-v2").querySelectorAll(`.featured-collection-v2__slider--all-items .featured-collection-v2__slider-item--wrapper[data-tab="${tabTarget}"]`);
        this.radio.addEventListener("change", this.toggleSliderItems.bind(this));

        window.addEventListener("load", this.repositionNavButtons.bind(this));

        if (window.visualViewport) {
          window.addEventListener("resize", this.repositionNavButtons.bind(this));
        }
        window.visualViewport.addEventListener("resize", this.repositionNavButtons.bind(this));
        window.addEventListener("orientationchange", this.repositionNavButtons.bind(this));
      }

      toggleSliderItems(event) {
        const tab = event.target;

        if (!tab.checked) {
          return;
        }

        const flkty = Flickity.data(this.slider);

        this.slider.querySelectorAll(".featured-collection-v2__slider-item--wrapper").forEach((item) => {
          flkty.remove(item);
        });

        this.targetSliderItems.forEach((item) => {
          flkty.append(item.cloneNode(true));
        });

        flkty.reloadCells();
        flkty.resize();
        flkty.select(0);
        this.repositionNavButtons();
      }

      repositionNavButtons() {
        setTimeout(() => {
          const maxWidth = this.slider.offsetWidth;
          const visibleSlides = this.slider.querySelectorAll(".featured-collection-v2__slider-item--wrapper.is-selected");
          const slideWidth = visibleSlides[0] ? visibleSlides[0].offsetWidth : 0;
          const navButtons = this.slider.querySelectorAll(".flickity-button");
          const buttonWidth = navButtons[0] ? navButtons[0].offsetWidth : 0;

          let offset = (maxWidth - visibleSlides.length * slideWidth) / 2 - buttonWidth;
          if (offset < this.fallbackCarouselButtonOffset) {
            offset = this.fallbackCarouselButtonOffset;
          }

          navButtons.forEach((button) => {
            if (button.classList.contains("previous")) {
              button.style.left = `${offset}px`;
            } else if (button.classList.contains("next")) {
              button.style.right = `${offset}px`;
            }
          });
        }, 200);
      }
    }
  );
}
